import styled from "styled-components";

// Card-sized tiles that wrap (as many per row as fit, one per row on a phone),
// shared by the campaign editor's Web Forms and Signup Email lists so they
// match. Cards line up at the top rather than stretching to their row.
const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(260px, 100%), 340px));
  gap: 12px;
  align-items: start;
`;

export default CardGrid;
